module.exports = {
	"title": "Title",
	"text": "Text",
	"add": "เพิ่มคำ",
	"deleteConfirmText": "ลบคำ",
	"chooseWord": "เลือกคำ"
};


//////////////////
// WEBPACK FOOTER
// ./src/locale/th/wordboard.json
// module id = 841
// module chunks = 1